import { Component, ViewChild } from '@angular/core';
import {ProcessoService} from "../../../services/processo-service";
import {ToastrService} from "ngx-toastr";
import {ListaProcesso} from "../../../models/lista-processo";
import { NovoComponent } from '../novo/novo.component';
import { Router } from '@angular/router';

@Component({
    selector: 'app-lista',
    templateUrl: './lista.component.html',
    styleUrl: './lista.component.css',
    standalone: false
})
export class ListaComponent {
  @ViewChild(NovoComponent) novoProcessoComponent: NovoComponent;
  loading = true;
  listaProcesso = new ListaProcesso();
  processosAgrupados: { pasta: string, processos: any[], aberta: boolean }[] = [];
  paginaAtual = 1;
  filtro = '';

  constructor(private processoService: ProcessoService,
              private toastr: ToastrService,
              private router: Router) {
    this.buscarListaProcessos();
  }

  public pageChange(event: number){
    this.paginaAtual = event;
  }

  filtrar(){
    if(this.filtro.length > 2){
      this.listaProcesso.itens = this.listaProcesso.itens.filter(x => x.cliente.toUpperCase().includes(this.filtro.toUpperCase())  ||
        x.titulo.toUpperCase().includes(this.filtro.toUpperCase())  ||
        x.pasta.toUpperCase().includes(this.filtro.toUpperCase()));
      this.agruparProcessos();
    }
    if(this.filtro.length <= 2){
      this.buscarListaProcessos();
    }
  }

  limparFiltro(){
    this.filtro = '';
    this.buscarListaProcessos();
  }

  abrirModalNovoProcesso(){
    this.novoProcessoComponent.showModalNovoProcesso();
  }

  public buscarListaProcessos(){
    this.processoService.selecionarLista().subscribe(response => {
        this.loading = false;
        if(response.sucesso){
          this.listaProcesso = response.dados;
          this.agruparProcessos();
        }}, error =>{
        this.loading = false;
        if(error.status == 404){
          this.toastr.warning('Não existe processo cadastrado', 'Lista vazia');
        }
        else
            this.toastr.error('Erro ao listar processo: ' + error, 'Erro');
      });
  }

  agruparProcessos() {
    const grupos = this.listaProcesso.itens.reduce((acc, processo) => {
      const pasta = processo.pasta || 'Sem Pasta';
      if (!acc[pasta]) {
        acc[pasta] = [];
      }
      acc[pasta].push(processo);
      return acc;
    }, {} as { [key: string]: any[] });

    this.processosAgrupados = Object.keys(grupos).map(pasta => ({
      pasta,
      processos: grupos[pasta],
      aberta: false
    }));
  }

  togglePasta(grupo: any) {
    grupo.aberta = !grupo.aberta;
  }

  getStatusDescricao(status: number): string {
    switch (status) {
      case 0: return 'Aberto';
      case 1: return 'Oficio';
      case 2: return 'Fechado';
      case 3: return 'Aguardando sentença';
      case 4: return 'Aguardando audiência';
      default: return '';
    }
  }

  abrirDetalhes(id: number){
    this.router.navigate(['/juridico/processo/detalhes', id]);
  }
}
